import {
  objectToQueryString,
  setQueryStringParam,
  getQueryStringParams,
  deleteQueryStringParam,
  parseIdsFromQueryParam,
  sanitizeIds,
} from "../../shared/utils";

export function triageImprovementsModal({ triageImprovementsUrl }) {
  return {
    open: false,
    initialLoad: false,
    loading: false,
    data: {},
    sort: "squad",
    sortDir: "asc",
    squadIds: [],

    init() {
      const queryParams = getQueryStringParams();
      const improvementsFromParams = queryParams.get("show_improvements");
      const squadIdsFromParams = parseIdsFromQueryParam(
        "improvements_squad_ids",
      );

      if (squadIdsFromParams?.length) {
        this.squadIds = squadIdsFromParams;
      }

      if (improvementsFromParams === "true") {
        this.openImprovementsModal();
      }
    },

    openImprovementsModal() {
      this.open = true;
      this.updateQueryParams();
      this.fetchImprovementsData();
    },

    updateQueryParams() {
      setQueryStringParam("show_improvements", "true");
      setQueryStringParam(
        "improvements_squad_ids",
        this.squadIds?.join(",") || null,
      );
    },

    clearImprovementsQueryParams() {
      deleteQueryStringParam("show_improvements");
      deleteQueryStringParam("improvements_squad_ids");
    },

    changeSquadIds(squadIds) {
      this.squadIds = sanitizeIds(squadIds);
      this.updateQueryParams();
      this.refetch();
    },

    refetch() {
      this.fetchImprovementsData();
    },

    get params() {
      const paramObj = {
        squad_ids: `${this.squadIds.join(",")}`,
      };

      return `?${objectToQueryString(paramObj)}`;
    },

    fetchImprovementsData() {
      this.loading = true;
      fetch(`${triageImprovementsUrl}${this.params}`)
        .then((response) => response.json())
        .then((resp) => {
          this.data = resp;
          this.initialLoad = true;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error fetching improvements data:", error);
          this.data = {
            improvements: [],
            num_improvement_areas: 0,
            num_improved_teams: 0,
            num_teams_with_improvement_areas: 0,
          };
          this.initialLoad = true;
          this.loading = false;
        });
    },

    get improvementAreaSuccessRate() {
      const { improvements, num_improvement_areas } = this.data;
      if (!improvements || !num_improvement_areas) return 0;

      const denominator = Math.max(num_improvement_areas, 1);
      return Math.round((improvements.length / denominator) * 100);
    },

    get sortedImprovements() {
      if (!this.data.improvements) return [];

      let list = [...this.data.improvements];

      // Sort by the selected column
      if (this.sort === "squad") {
        list = list.sort((a, b) => a.squad.localeCompare(b.squad));
      } else if (this.sort === "squad_manager") {
        list = list.sort((a, b) =>
          a.manager.name.localeCompare(b.manager.name),
        );
      } else if (this.sort === "factor") {
        list = list.sort((a, b) => a.factor.localeCompare(b.factor));
      } else if (this.sort === "sentiment") {
        list = list.sort((a, b) => a.sentiment_change - b.sentiment_change);
      } else if (this.sort === "priority") {
        list = list.sort((a, b) => -a.priority_change - -b.priority_change);
      }

      // Reverse if descending
      if (this.sortDir === "desc") {
        list = list.reverse();
      }

      return list;
    },

    changeSort(col) {
      if (this.sort === col) {
        // Toggle sort direction if clicking the same column
        this.sortDir = this.sortDir === "desc" ? "asc" : "desc";
      } else {
        // Set new column and default to desc
        this.sort = col;
        this.sortDir = "desc";
      }
    },
  };
}
